import { createApi } from '@reduxjs/toolkit/query/react'
import RtkBaseQueryWithReauth from './RtkBaseQueryWithReauth'
import ApiPath from './ConstantApi'
import { FaqDataModel, FAQResponseModel } from '../Helpers/Interfaces/FaqType'


export const faqApi = createApi({
  reducerPath: 'faqApi',
  baseQuery: RtkBaseQueryWithReauth(process.env.REACT_APP_BASE_URL || ''),
  tagTypes: ['FAQ','PRODUCT_FAQ'],
  endpoints: (builder) => ({
    // Returns the whole envelope, not just .data, because the list needs
    // totalPages to paginate. The API already supported page/pageSize -- only
    // the client never sent them, so every FAQ loaded into one long list.
    getFaqList: builder.query<any, { page?: number; pageSize?: number } | void>({
      query: (args) => ({
        url: ApiPath.faqList,
        method: 'GET',
        params:
          args && args.page && args.pageSize
            ? { page: args.page, pageSize: args.pageSize }
            : undefined,
      }),
      providesTags: ['FAQ']
    }),

    updateFaq: builder.mutation({
      query: ({ _id, data }:any) => ({
        url: `${ApiPath.faqUpdate}/${_id}`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ['FAQ']
    }),

    addFaq: builder.mutation({
      query: (data) => ({
        url: `${ApiPath.faqAdd}`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['FAQ']
    }),

    deleteFaq: builder.mutation({
      query: ({ categoryId, faqId }) => ({
        url: `${ApiPath.faqDelete}/${categoryId}/${faqId}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['FAQ']
    }),

    // 'PRODUCT_FAQ'
    getProductFaqList: builder.query({
      query: ({page, pageSize, faqId, search}: {page:number, pageSize:number, faqId?:string, search?:string}) => ({
        url: `${ApiPath.faqProductList}${faqId ? `/${faqId}` : ''}?page=${page}&pageSize=${pageSize}${search ? `&search=${encodeURIComponent(search)}` : ''}`,
        method: 'GET'
      }),
      providesTags: ['PRODUCT_FAQ']
    }),

    updateProductFaq: builder.mutation({
      query: ({ _id, data }:any) => ({
        url: `${ApiPath.faqProductUpdate}/${_id}`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ['PRODUCT_FAQ']
    }),

    addProductFaq: builder.mutation({
      query: (data) => ({
        url: `${ApiPath.faqProductAdd}`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['PRODUCT_FAQ']
    }),

    deleteProductFaq: builder.mutation({
      query: (faqId) => ({
        url: `${ApiPath.faqProductDelete}/${faqId}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['PRODUCT_FAQ']
    })
  })
})

export const {
  useGetFaqListQuery,
  useUpdateFaqMutation,
  useAddFaqMutation,
  useDeleteFaqMutation,

  useGetProductFaqListQuery,
  useLazyGetProductFaqListQuery,
  useUpdateProductFaqMutation,
  useAddProductFaqMutation,
  useDeleteProductFaqMutation
} = faqApi
  